import React from 'react';

const IconErrorCircle = ({ className }) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6308 12.3986L12.3986 10.6309L20 18.2323L27.6014 10.6309L29.3692 12.3986L21.7678 20L29.3692 27.6014L27.6014 29.3692L20 21.7678L12.3986 29.3692L10.6308 27.6014L18.2322 20L10.6308 12.3986Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2ZM4.5 20C4.5 11.4396 11.4396 4.5 20 4.5C28.5604 4.5 35.5 11.4396 35.5 20C35.5 28.5604 28.5604 35.5 20 35.5C11.4396 35.5 4.5 28.5604 4.5 20Z"
      fill="black"
    />
  </svg>
);

export default IconErrorCircle;
